import $ from 'jquery'

function init () {
  $('.teamwall-container .modal').each(function () {
    let $modal = $(this)
    $modal.find('.modal-close').on('click', () => {
      $modal.modal('hide')
    })
  })
}

export default {
  init
}
